import { extractImageId } from "utils/Validators";
import {
  IBannerPageState,
  IBannersResponse,
  IBannersResponseNormalized,
  IUpdateBannerPayload,
} from "../interfaces/banner.interface";
import { imageUploadKeys } from "components/pages/banner/BannerDetail/BannerDetailPage.types";

export const normalizeFetchBanners = (
  res: IBannersResponse[]
): IBannersResponseNormalized[] => {
  return res.map((dto) => normalizeBannerResponseDto(dto));
};

export const normalizeBannerResponseDto = (
  dto: IBannersResponse
): IBannersResponseNormalized => {
  return {
    id: dto.id,
    cityId: dto.cityId,
    bannerTitle: dto.title,
    w400Xh400: {
      imageId: extractImageId(dto.images?.w400Xh400) || "",
      base64StringUrl: dto.images?.w400Xh400,
      multiPartData: "",
    },
    w2000Xh375: {
      imageId: extractImageId(dto.images?.w2000Xh375) || "",
      base64StringUrl: dto.images?.w2000Xh375,
      multiPartData: "",
    },
    bannerDescription: dto.description,
    type: dto.type,
    status: dto.status,
    products: dto.products,
  };
};

export const normalizeBannerImagePayload = (
  payload: IBannerPageState,
  key: imageUploadKeys
) => {
  let formData: any = new FormData();
  const imageData =
    payload[key] && (payload[key]! as any).multiPartData
      ? (payload[key]! as any).multiPartData
      : "";
  formData.append("image", imageData);
  return formData;
};

export const normalizeUpdateBannerPayload = (
  payload: IBannerPageState
): IUpdateBannerPayload => {
  return {
    id: payload.id,
    cityId: payload.cityId,
    title: payload.bannerTitle,
    description: payload.bannerDescription,
    imageId: payload.w400Xh400.imageId,
    status: payload.status ? "ACTIVE" : "INACTIVE",
    type: payload.bannerType,
    customerChannel: payload.customerChannel,
    bannerImages: {
      w400Xh400: payload.w400Xh400.imageId,
      w2000Xh375: payload.w2000Xh375.imageId,
    },
  };
};

export const normalizeUpdateBannerProductsPayload = (payload: any[]) => {
  const productPayload: any = {
    products: {},
  };

  payload.forEach((item, index) => {
    productPayload.products[item.variantId] = {
      order: index + 1,
    };
  });

  return productPayload;
};
